import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-report',
  templateUrl: './service-report.component.html',
  styleUrls: ['./service-report.component.scss']
})
export class ServiceReportComponent implements OnInit {
  
  resultAgendamentoSemanal: Array<any> = [
    {pagos: 10,gratuitos: 18, total: 28}, 
    {pagos: 20,gratuitos: 27, total: 47}, 
    {pagos: 15,gratuitos: 21, total: 36}, 
    {pagos: 12,gratuitos: 12, total: 24},  
    {pagos: 20,gratuitos: 25, total: 45}, 
    {pagos: 15,gratuitos: 16, total: 31}, 
    {pagos: 17,gratuitos: 11, total: 29}
  ];
  resultAgendamentoDiario: Array<any> = [
    { pagos: 10, gratuitos: 20, total: 30 },
    { pagos: 15, gratuitos: 25, total: 40 },
    { pagos: 18, gratuitos: 22, total: 40 },
    { pagos: 12, gratuitos: 18, total: 30 },
    { pagos: 20, gratuitos: 25, total: 45 },
    { pagos: 8, gratuitos: 22, total: 30 },
    { pagos: 11, gratuitos: 19, total: 30 },
    { pagos: 17, gratuitos: 23, total: 40 },
    { pagos: 13, gratuitos: 27, total: 40 },
    { pagos: 14, gratuitos: 16, total: 30 },
    { pagos: 18, gratuitos: 22, total: 40 },
    { pagos: 20, gratuitos: 30, total: 50 },
    { pagos: 10, gratuitos: 21, total: 31 },
    { pagos: 16, gratuitos: 21, total: 37 },
    { pagos: 22, gratuitos: 23, total: 45 },
    { pagos: 12, gratuitos: 13, total: 25 },
    { pagos: 18, gratuitos: 32, total: 50 },
    { pagos: 15, gratuitos: 30, total: 45 },
    { pagos: 18, gratuitos: 13, total: 31 },
    { pagos: 10, gratuitos: 19, total: 29 },
    { pagos: 20, gratuitos: 18, total: 38 },
    { pagos: 16, gratuitos: 19, total: 35 },
    { pagos: 12, gratuitos: 16, total: 28 },
    { pagos: 10, gratuitos: 18, total: 28 },
    { pagos: 25, gratuitos: 25, total: 50 },
    { pagos: 22, gratuitos: 17, total: 39 },
    { pagos: 15, gratuitos: 18, total: 33 },
    { pagos: 19, gratuitos: 26, total: 45 },
    { pagos: 13, gratuitos: 20, total: 33 },
    { pagos: 13, gratuitos: 20, total: 33 }
  ];
  resultAgendamentoMensal: Array<any> = [
    { pagos: 10, gratuitos: 20, total: 30 },
    { pagos: 15, gratuitos: 25, total: 40 },
    { pagos: 18, gratuitos: 22, total: 40 },
    { pagos: 12, gratuitos: 18, total: 30 },
    { pagos: 20, gratuitos: 25, total: 45 },
    { pagos: 8, gratuitos: 22, total: 30 },
    { pagos: 11, gratuitos: 19, total: 30 },
    { pagos: 17, gratuitos: 23, total: 40 },
    { pagos: 13, gratuitos: 27, total: 40 },
    { pagos: 14, gratuitos: 16, total: 30 },
    { pagos: 18, gratuitos: 22, total: 40 },
    { pagos: 20, gratuitos: 30, total: 50 }
  ];

  
  barsAgendamentoDataDiario: Array<any> = this.resultAgendamentoDiario.map(b => b.total);
  barsAgendamentoLabelsDiario: Array<any> = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'];

  barsAgendamentoDataMensal: Array<any> = this.resultAgendamentoMensal.map(b => b.total);
  barsAgendamentoLabelsMensal: Array<any> = ['01/23', '02/23', '03/23', '04/23', '05/23', '06/23', '07/23', '08/23', '09/23', '10/23', '11/23', '12/23'];

  barsAgendamentoDataSemanal: Array<any> = this.resultAgendamentoSemanal.map(b => b.total);
  barsAgendamentoLabelsSemanal: Array<any> = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];



  agendamentosData : Array<any> = this.barsAgendamentoDataDiario; 
  agendamentosLabel : Array<any> = this.barsAgendamentoLabelsDiario; 

  tipoAgendamentosData : Array<any> = this.barsAgendamentoDataDiario; 
  tipoAgendamentosLabel : Array<any> = this.barsAgendamentoLabelsDiario; 

  ondeForamFeitos = {
    data: [71,18,11],
    colors: ['#FF8321','#AD5916','#999999'],
    labels: ['Funcionários','Widget','Marketing']
  }
  agendamentoServicoExame = {
    data: ['98','02'],
    colors: ['#7A95DC','#4C5C86'],
    labels: ['Fisioterapia','Consulta Médica']
  }
  agendamentoProfissional = {
    data: [40,30,20,'08','02'],
    colors: ['#FF8321','#AD5916','#7A95DC','#4C5C86','#999'],
    labels: ['Dr. Flávio','Dra. Gabriela','Dr. Anderson','Dr. Carlos','Dra. Maria']
  }
  distribuicaoAgendamentos = {
    data: [70,20,'08','02'],
    colors: ['#7A95DC','#4C5C86','#FF8321','#999'],
    labels: ['Consultas','Procedimentos','Exames','Cancelados']
  }

  optionAgendamentosBtn: any =  [
    { label: 'Diário', value: 'diario' }, { label: 'Semanal', value: 'semanal' } , { label: 'Mensal' , value : 'mensal'}
  ];
  addFilterOptions(event: any) {

  }

  ngOnInit() {
    
  }

  toogleAgendamentosBtn(btnSelected: any) {
    if(btnSelected.value == 'mensal'){
      this.agendamentosData = this.barsAgendamentoDataMensal;
      this.agendamentosLabel = this.barsAgendamentoLabelsMensal;
    }
    if(btnSelected.value == 'diario') {
      this.agendamentosData = this.barsAgendamentoDataDiario;
      this.agendamentosLabel = this.barsAgendamentoLabelsDiario;
    }
    if(btnSelected.value == 'semanal') {
      this.agendamentosData = this.barsAgendamentoDataSemanal;
      this.agendamentosLabel = this.barsAgendamentoLabelsSemanal;
    }
  }
  toogleTipoAgendamentosBtn(btnSelected: any) {
    if(btnSelected.value == 'mensal'){
      this.tipoAgendamentosData = this.barsAgendamentoDataMensal;
      this.tipoAgendamentosLabel = this.barsAgendamentoLabelsMensal;
    }
    if(btnSelected.value == 'diario') {
      this.tipoAgendamentosData = this.barsAgendamentoDataDiario;
      this.tipoAgendamentosLabel = this.barsAgendamentoLabelsDiario;
    }
    if(btnSelected.value == 'semanal') {
      this.tipoAgendamentosData = this.barsAgendamentoDataSemanal;
      this.tipoAgendamentosLabel = this.barsAgendamentoLabelsSemanal;
    }
  }
}
